import { render, staticRenderFns } from "./PropertyValue.vue?vue&type=template&id=15127009&"
import script from "./PropertyValue.vue?vue&type=script&lang=ts&"
export * from "./PropertyValue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports